export default {
  name: "Local",
  center: {
    lon: -2.9,
    lat: 38.853,
    zoom: 6
  },
  sectors: [
    {
      name: "Energy(TRL+)",
      alias: "Energy (TRL+)",
      url: "http://dss.trlplus.com/",
      description:
        "Decision Support System to support marine renewable energy developers from a conceptual to a real farm",
      types: []
    }
  ]
};
